import { useCallback, useEffect } from 'react';

import { FeatureProtectedView } from '@moniebook-web/components/molecules/feature-protected-view';
import { FlagProviderWrapper } from '@moniebook-web/components/molecules/flag-provider-wrapper';
import { ServiceUnavailable } from '@moniebook-web/components/widgets/service-unavailable';
import { useFeatureFlagStore } from '@moniebook-web/store';
import { chatSDKLauncher } from '@moniedesk-chat/sdk';
import { Outlet } from 'react-router';

import { MoniedeskChat } from '@/integrations/moniedesk';
import { FEATURE_FLAGS } from '@/shared/constants';

import { ErrorBoundary } from './error-boundary';
import { MixpanelPageViews } from './mixpanel-page-views';

export function RouteWrapper() {
    return (
        <ErrorBoundary fallback={<ServiceUnavailable />}>
            <FlagProviderWrapper>
                <FeatureProtectedView
                    noAltView
                    flag={FEATURE_FLAGS.ENABLE_MONIEDESK_CHAT}>
                    <MoniedeskChat />
                </FeatureProtectedView>
                <MoniedeskChatUnload />
                <MixpanelPageViews />
                <Outlet />
            </FlagProviderWrapper>
        </ErrorBoundary>
    );
}

/**
 * This component exists solely to control the Moniedesk chat Widget via feature flag and should be removed when the feature flag is no longer needed.
 * Due to the way the Moniedesk chat works, once initialized, removing the component that initialized it(<MoniedeskChat />) from the DOM when the feature flag is turned off does not remove the chat widget until the page is refreshed.
 */
function MoniedeskChatUnload() {
    const { featureFlags } = useFeatureFlagStore();
    const enableChat = featureFlags?.[FEATURE_FLAGS.ENABLE_MONIEDESK_CHAT];

    const unloadChat = useCallback(() => {
        if (chatSDKLauncher.isLoaded()) {
            chatSDKLauncher.unload();
        }
    }, []);

    useEffect(() => {
        if (!enableChat) {
            unloadChat();
        }
    }, [enableChat, unloadChat]);

    return null;
}
